import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { ScarcityFragmentFragmentDoc } from '@packages/gql/generated/shopping/ScarcityFragmentFragmentDoc';
import { useIntl } from 'react-intl';
import { Flag } from '@packages/shared';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { scarcityMessages } from './messages';

/* GraphQL */ `
  fragment ScarcityFragment on Availability {
    limitedStock
  }
`;

type ScarcityProps = {
  data: FragmentType<typeof ScarcityFragmentFragmentDoc>;
};

export const Scarcity = ({ data }: ScarcityProps) => {
  const { limitedStock } = getFragmentData(ScarcityFragmentFragmentDoc, data);
  const { formatMessage } = useIntl();
  const {
    product: { hasScarcity },
  } = useConfig();

  return hasScarcity && limitedStock ? (
    <Flag
      text={formatMessage(scarcityMessages.text)}
      type="contrast"
      sx={{ backgroundColor: 'common.black' }}
    />
  ) : null;
};
